import { Input, makeStyles } from '@fluentui/react-components';
import { Search } from '@material-symbols-svg/react/rounded/w500';

import { MONO_FONT, palette, tokens } from '../../theme';
import { DotSpinner } from '../spinner';

export type SearchBoxProps = {
    value: string;
    onChange: (value: string) => void;
    isLoading?: boolean;
};

export const SearchBox: React.FC<SearchBoxProps> = ({ value, onChange, isLoading = false }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Search className={classes.icon} aria-hidden />
            <Input
                className={classes.input}
                appearance="filled-lighter"
                value={value}
                placeholder="Search issues, bugs…"
                onChange={(_, data) => onChange(data.value)}
            />
            {isLoading ? (
                <DotSpinner label="Searching" />
            ) : (
                <span className={classes.shortcut} aria-hidden>
                    ⌘K
                </span>
            )}
        </div>
    );
};

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
        backgroundColor: palette.panelBg,
        border: `1px solid ${palette.cardBorder}`,
        borderRadius: tokens.borderRadiusMedium,
        padding: `0 ${tokens.spacingHorizontalM}`,
        '&:focus-within': {
            border: `1px solid ${palette.selectedAccent}`,
        },
    },
    icon: {
        width: '16px',
        height: '16px',
        color: tokens.colorNeutralForeground3,
        flexShrink: 0,
    },
    input: {
        flex: 1,
        backgroundColor: 'transparent',
        border: 'none',
        '&::after': {
            content: 'none',
        },
        '&::before': {
            content: 'none',
        },
    },
    shortcut: {
        backgroundColor: palette.panelMuted,
        borderRadius: tokens.borderRadiusSmall,
        padding: '1px 6px',
        fontFamily: MONO_FONT,
        fontSize: '10.5px',
        color: tokens.colorNeutralForeground3,
        flexShrink: 0,
    },
});
